import { request } from 'umi';
import type { ForceChangePwdParams, ResetPwdParams, UpdateRoleInfoParams } from './data';

/** core--通用身份验证接口--[B端]通过用户id发送短信验证码
 * @method GET
 * @url /core/auth/generic/client/code/user
 * @param {String} mobile   *新手机号
 */
export async function getCaptchaByPhone(params: { mobile: string }) {
  return request('/core/auth/generic/client/code/user', { params })
}

/** core--用户账号接口--强制修改密码
 * @method POST
 * @url /core/user/account/pwd-change-force
 * @param {String} account      *用户账号
 * @param {Number} mobile       *用户手机号
 * @param {String} code         *手机验证码
 * @param {String} codeId       *验证码唯一标识
 * @param {String} newPassword  *新密码
 */
export async function forceChangePwd(data: ForceChangePwdParams) {
  return request('/core/user/account/pwd-change-force', {
    method: 'POST',
    data
  })
}

/** core -- 用户(员工管理接口) -- 编辑用户(账号、姓名、手机号)
 * https://test.lanxihealthcare.com/api/core/doc.html#/default/用户(员工)管理接口/updateUserInfoUsingPOST
 * @method POST
 * @url /core/user/account/update
 * @param {String} account          用户账号
 * @param {String} avatarUrl        用户头像
 * @param {Number} birthday         用户生日
 * @param {Number} dataControl      用户数据访问权限 0：查看本人客户 1：查看本机构客户
 * @param {String} id               用户id 添加用户时不需要此字段
 * @param {String} mobile           用户联系电话
 * @param {String} name             用户姓名
 * @param {String} orgId            用户所属机构 id
 * @param {String} orgIds           用户机构权限: 为空则置空
 * @param {String} resume           简历
 * @param {String} roleId           用户角色id
 * @param {Number} serviceUserFlag  服务人员标识 0：非服务人员 1：服务人员
 * @param {Number} sex              用户性别
 * @param {Number} status           账号状态: 1启用, 2禁用
 * @param {Number} teamId           服务团队：新增员工时不传则为创建新团队
 */
export async function updateRoleInfo(data: UpdateRoleInfoParams) {
  return request('/core/user/account/update', {
    method: 'POST',
    data
  })
}

/**
 *
 * @param params
 */
export async function pwdChange (data: ResetPwdParams) {
  return request('/core/user/account/pwd-change', {
    method: 'POST',
    data
  })
}

/** core -- 前端i18n语言问卷相关接口 -- 查询列表
 * 接口地址：https://www.apifox.cn/web/project/1822157/apis/api-60111676
 * POST /core/language/list
 */
export async function fetchLanguageList() {
  return request('/core/language/list', {
    method: 'POST',
  })
}

/** core -- 前端i18n语言问卷相关接口 -- 新增或更新
 * 接口地址：https://www.apifox.cn/web/project/1822157/apis/api-60111678
 * POST /core/language/saveOrUpdateBatch
 * @param {Number} id      id
 * @param {String} code    *语言 id
 * @param {String} value   *语言 defaultMessage
 */
export async function modifyLanguageList(data: { id?: number, code: string, value: string }[]) {
  return request('/core/language/saveOrUpdateBatch', {
    method: 'POST',
    data
  })
}
